






























import Element from '../../../mixins/element';
import CardType from '../../../components/CardType.vue';
import { Component } from 'vue-property-decorator';
import { hardCodeBrand, getCardType, clearCard } from '../../../../services';


@Component({
    components: {
        CardType,
    },
})
export default class CreditCard extends Element {
   public forceFormatCard(value) {
      (this.$refs.input as any).value = value;
   }

   public toMount(): void {
      this.onLoading(false);
      (this.$refs.input as any).onchange = (e) => {
         this.input = {
               value: null,
               brand: hardCodeBrand(e.detail.brand),
         };
      };
   }

   public toDestroy(): void {}

   public toValidate(): boolean {
      return true;
   }

   public toClear(): void {}

   public toFocus(): void {}

   public toBlur(): void {}
}
